import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateTracPageSuccess } from '../action-creators';
import { UPDATE_TRAC_PAGE_SUCCESS } from '../actions';
import { UpdateAchievement } from '@webapp/store/artist/action-creators';
import AppState from '../../state';
import { TracPage } from '@services/tracpage/types/trac-page';
import { NoOp } from '@webapp/store/ui/action-creators';
import { removeLocalStorageItem } from '@webapp/utils/localstorage';
import { buildTracPageDraftStorageKey } from './store-tracpage-edits';
import { buildDraftsStorageKey } from '@webapp/store/traclink/effects/store-event-drafts';

export const updateTracPageSuccessEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, UpdateTracPageSuccess<TracPage>>(UPDATE_TRAC_PAGE_SUCCESS),
    withLatestFrom(state$),
    map(([action, state]) => {
      removeLocalStorageItem(buildTracPageDraftStorageKey(action.tracPage.id));
      removeLocalStorageItem(buildDraftsStorageKey(action.tracPage.ownerId));
      if (state.artist.active) {
        let id = state.artist.achievements.find(
          (val) => val.achievementKey === 'customize-trac-page'
        )?.id;
        if (!state.artist.active.achievements?.includes(id || '')) {
          if (id) {
            return new UpdateAchievement(state.artist.active.id, id as string);
          }
        }
        return new NoOp();
      }
      return new NoOp();
    })
  );
